'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactIntl = require('react-intl');
var Button = _interopDefault(require('@material-ui/core/Button'));
var TwoToneButton = require('../../../buttons/TwoToneButton/TwoToneButton.js');
var InputAdornment = _interopDefault(require('@material-ui/core/InputAdornment'));
var FormControl = _interopDefault(require('@material-ui/core/FormControl'));
var ArrowUpwardIcon = _interopDefault(require('@material-ui/icons/ArrowUpward'));
var emojiMart = require('emoji-mart');
require('emoji-mart/css/emoji-mart.css');
var styledComponents = require('./styled-components.js');

var ENTER_KEY = 13;
var ChatInput = function (props) {
    var onSend = props.onSend;
    var _a = React.useState(false), pickerVisible = _a[0], setPickerVisible = _a[1];
    var _b = React.useState(''), text = _b[0], setText = _b[1];
    var intl = reactIntl.useIntl();
    var fm = intl.formatMessage;
    var addEmoji = function (newEmoji) {
        if (newEmoji) {
            setText(text + String(newEmoji.native));
        }
    };
    var handleTextChange = function (_a) {
        var target = _a.target;
        setText(target.value);
    };
    var handleClick = function () {
        if (onSend) {
            onSend(text);
        }
        setText('');
    };
    var showEmojis = function () {
        setPickerVisible(!pickerVisible);
    };
    var hideEmojis = function () {
        if (pickerVisible) {
            setPickerVisible(false);
        }
    };
    var submitOnEnter = function (event) {
        if (event.charCode === ENTER_KEY) {
            handleClick();
        }
    };
    return (React__default.createElement(styledComponents.Main, { id: 'chatinput' },
        React__default.createElement(styledComponents.FlexContainer, null,
            React__default.createElement(styledComponents.InputContainer, null,
                React__default.createElement(FormControl, { fullWidth: true, variant: 'outlined' },
                    React__default.createElement(styledComponents.StyledInput, { autoComplete: 'new-password', onKeyPress: submitOnEnter, id: 'outlined-adornment-amount', value: text, onChange: handleTextChange, onClick: hideEmojis, disableUnderline: true, endAdornment: React__default.createElement(InputAdornment, { position: 'start' },
                            React__default.createElement(Button, { onClick: showEmojis },
                                React__default.createElement(styledComponents.StyledSpan, null, "\u263A"))) }))),
            React__default.createElement(styledComponents.ButtonContainer, null,
                React__default.createElement(TwoToneButton, { disabled: !text, clickHandler: handleClick, text: fm({ id: 'componentLib.appWide.send' }), colorLeft: '#3f69e1', colorRight: '#4c7cfd', textColorLeft: 'white', textColorRight: 'white', icon: function () { return React__default.createElement(ArrowUpwardIcon, null); } })),
            pickerVisible && (React__default.createElement(emojiMart.Picker, { onSelect: addEmoji, title: fm({ id: 'componentLib.chatInput.pickEmoji' }), style: { position: 'fixed', width: '346px', bottom: '12%', right: '15%' } })))));
};

module.exports = ChatInput;
